import { IAppState } from '../../common/state';
import { ICoordinates } from '../../types/newbuildingHeader';

export const getMapCoordinates = ({ newbuildingInformation }: IAppState): ICoordinates | null => {
  return newbuildingInformation?.geo?.coordinates || null;
};
